/** @file Structured error/warning value used across the API boundary and by the UI for translation. */
import { ERROR_CODES, type ErrorCode } from './errorCodes';

export interface Pose2DError {
  code: ErrorCode;
  /** English message with params interpolated (MCP/REST); the UI re-renders from code + params. */
  message: string;
  params?: Record<string, string | number>;
  /** JSON-pointer-like path into the offending input or document, e.g. `bones.bone_01/setup.x`. */
  path?: string;
  hint?: string;
}

/** Builds a Pose2DError, interpolating `{param}` placeholders of the code's template. */
export function makeError(
  code: ErrorCode,
  params?: Record<string, string | number>,
  extra?: { path?: string; hint?: string },
): Pose2DError {
  const message = ERROR_CODES[code].replace(/\{(\w+)\}/g, (_, k: string) => String(params?.[k] ?? `{${k}}`));
  return {
    code,
    message,
    ...(params ? { params } : {}),
    ...(extra?.path !== undefined ? { path: extra.path } : {}),
    ...(extra?.hint !== undefined ? { hint: extra.hint } : {}),
  };
}
